<app-header
  class="user-panel-toolbar"
  [orders]="orders"
  [isAuthenticated]="isAuthenticated"
/>

<div id="appOutlet">
  <router-outlet class="appOutlet" />
</div>
<!-- <app-footer></app-footer> -->
